// extracted by mini-css-extract-plugin
module.exports = {"textNotice_input":"Notice_textNotice_input__2BI_H","notify_alert":"Notice_notify_alert__1n9e-","button_save_notice":"Notice_button_save_notice__2jyJv"};